// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"1eca3c51","340":"e4e06c0a","653":"134889ad","679":"9f98a98a","722":"691861ac"}[chunkId] + ".chunk.css";
};